function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingConnectionDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "113.169 142.943 244.633 195.312",
    width: 244.633,
    height: 195.312,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "https://boxy-svg.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--txt-color)",
      stroke: "var(--txt-color)",
      strokeWidth: 3
    },
    d: "M 315.748 152.492 L 254.018 194.131",
    transform: "matrix(-0.93632, 0.351148, -0.351148, -0.93632, 612.482605, 235.550461)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--txt-color)",
      stroke: "var(--txt-color)",
      strokeWidth: 3
    },
    d: "M 218.546 194.093 L 156.816 152.455",
    transform: "matrix(0.93632, 0.351148, -0.351148, 0.93632, 72.796326, -54.869701)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--txt-color)",
      stroke: "var(--txt-color)",
      strokeWidth: 3
    },
    d: "M 312.481 329.235 L 254.181 289.91",
    transform: "matrix(-0.93632, -0.351148, 0.351148, -0.93632, 439.913727, 698.922485)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--txt-color)",
      stroke: "var(--txt-color)",
      strokeWidth: 3
    },
    d: "M 220.679 289.946 L 162.379 329.271",
    transform: "matrix(0.93632, -0.351148, 0.351148, 0.93632, -96.521828, 86.970894)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "var(--accents-color)",
      fill: "var(--accents-color)"
    },
    x: 177.902,
    y: 200,
    width: 115.237,
    height: 83.544,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--txt-color)",
      stroke: "var(--txt-color)",
      strokeWidth: 5
    },
    d: "M 177.762 244.364 L 113.169 244.364"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--txt-color)",
      stroke: "var(--txt-color)",
      strokeWidth: 5
    },
    d: "M 357.802 242.508 L 293.209 242.508",
    xlinkHref: "0.515 0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingConnectionDark);
export default __webpack_public_path__ + "static/media/floatingConnectionDark.09356d02f656858ca90c68d19f69e97c.svg";
export { ForwardRef as ReactComponent };